<template lang="pug">
  .container.grid-xl
    .card.mt-2
      .card-header
        .text-bold Filtrar
      .card-body
        form-filter(@submit="fetchReport")
    .full-height.loading.loading-lg(v-if="loading")
    div(v-else-if="report")
      div(v-if="Object.values(report).length")
        .card.my-2
          .card-header
            .h5 Tabela resumo
          .card-body
            table.table.table-striped.table-responsive
              thead
                tr
                  th {{ 'doc.fiscal' | tModel }}
                  th.text-right(v-for="faixa in report.faixas") {{ faixa }} 
              tbody
                tr(v-for="item, fiscal in report.data")
                  td {{ fiscal }}
                  td.text-right(v-for="faixa in item")
                    div
                      small Quantidade #[span.text-bold {{ faixa.q }}]
                    div
                      small Valor #[span.text-bold {{ faixa.valor_total | currency('R$ ') }}]
              tfoot
                tr
                  th Total
                  th.text-right(v-for="col in totais")
                    div
                      small Quantidade: #[span.text-bold {{ col.q }}]
                    div
                      small Valor: #[span.text-bold {{ col.valor_total | currency('R$ ')}}]
      .card.mt-2(v-else)
        .card-body
          .empty
            .empty-icon
              i.fa.fa-search.fa-4x
            p.empty-title.h5 Nada encontrado
            p.empty-subtitle Não foram encontradas Notificações neste período
</template>

<script>
import { deepKey } from 'paliari-js-utils'
import toastErrors from '@/lib/errors/toastErrors'
import notificacoes from '@/api/indicadores/docs'
import FormFilter from './components/Filter'

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    totais() {
      if (!deepKey(this.report, 'data') || !deepKey(this.report, 'faixas'))
        return []
      const soma = {}
      Object.values(this.report.faixas).forEach(coluna => {
        soma[coluna] = { q: 0, valor_total: 0 }
      })
      Object.values(this.report.data).forEach(data => {
        Object.keys(data).forEach(coluna => {
          soma[coluna].q += Number(data[coluna].q)
          soma[coluna].valor_total += Number(data[coluna].valor_total)
        })
      })

      return Object.values(soma)
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await notificacoes.porFiscalFaixa({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>

<style lang="stylus" scoped>
.chart-body
  max-height 500px
  overflow-y auto
</style>
